import React from "react";

const VerticalContainer = ({ children }) => {
  return (
    <div className="flex items-center justify-center bg-white">
      <div className="max-w-screen-sm w-full bg-black">
        {children}
      </div>
    </div>
  );
};

export default VerticalContainer;
